module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"common\" class=\"tab-pane fade\">\r\n    <p>Common tools here</p>\r\n</div>\r\n<div id=\"report\" class=\"tab-pane fade\">\r\n    <p>app tools here</p>\r\n</div>\r\n<div id=\"general\" class=\"tab-pane fade\">\r\n\r\n</div>\r\n<div id=\"integration\" class=\"tab-pane fade\">\r\n    <p>integration tools here</p>\r\n</div>\r\n<div id=\"objects\" class=\"tab-pane fade\">\r\n    <p>objects tools here</p>\r\n</div>\r\n<div id=\"all\" class=\"tab-pane fade  active in\">\r\n\r\n\r\n</div>")
  }
  return __output;

}